<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-10-17 15:54:45
 * @FilePath: /adm.xiangli360.com/src/views/Setting/MenuManagement/components/AddOrEdit.vue
-->
<template>
  <el-dialog
    class="dialog-bg dialog-add-edit"
    :title="type == 'add' ? '新增菜单' : '编辑菜单'"
    :visible.sync="showAddOrEdit"
    :before-close="close"
    width="720px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="上级菜单" prop="parentId">
            <!-- :disabled="type == 'edit'" -->
            <treeseLect
              v-model="form.parentId"
              :options="menuList"
              :normalizer="normalizer"
              :show-count="true"
              @select="selectTreeNode"
              noResultsText="暂无数据"
              placeholder="选择上级菜单"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="form.menuType != '4'">
          <el-form-item label="菜单图标" prop="icon">
            <el-popover
              placement="bottom-start"
              width="460"
              trigger="click"
              @show="$refs['iconSelect'].reset()"
            >
              <IconSelect
                :icon="form.icon"
                :iconLoad="iconLoad"
                ref="iconSelect"
                @selected="selected"
              />
              <el-input
                :class="{ 'icon-input': iconObj.icon }"
                slot="reference"
                v-model="iconObj.text"
                placeholder="点击选择图标"
                readonly
              >
                <i
                  slot="prefix"
                  :class="
                    iconObj.icon
                      ? `iconfont ${iconObj.icon}`
                      : 'el-icon-search el-input__icon'
                  "
                />
                <i
                  v-show="iconObj.icon && iconObj.text"
                  style="cursor: pointer"
                  slot="suffix"
                  @click.stop="clearIconObj"
                  class="el-icon-circle-close el-input__icon"
                />
              </el-input>
            </el-popover>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="菜单类型" prop="menuType">
            <el-radio-group v-model="form.menuType">
              <!-- <el-radio :label="2">目录</el-radio> -->
              <el-radio :label="3">菜单</el-radio>
              <el-radio :label="4">按钮</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.menuType == '3'">
          <el-form-item label-width="146px">
            <span slot="label"> 是否是下拉菜单 </span>
            <el-radio-group v-model="form.pullDownFlag">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="form.menuType == 3 ? 11 : 12">
          <el-form-item label="菜单名称" prop="menuName">
            <el-input v-model="form.menuName" placeholder="请输入菜单名称" />
          </el-form-item>
        </el-col>
        <el-col :span="form.menuType == 3 ? 13 : 12">
          <el-form-item
            prop="urlAddress"
            :label-width="form.menuType == 3 ? '128px' : ''"
          >
            <span slot="label">
              <el-tooltip
                content="访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
              路由地址
            </span>
            <el-input v-model="form.urlAddress" placeholder="请输入路由地址" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="form.menuType == '4'">
          <el-form-item>
            <span slot="label"> 按钮标识 </span>
            <el-input v-model="btnCode" placeholder="请输入按钮标识" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-col :span="12">
            <el-form-item prop="moduleName">
              <span slot="label"> 组件名称 </span>
              <el-input
                v-model="form.moduleName"
                placeholder="请输入组件名称"
                @input="onInput()"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="component">
              <span slot="label">
                <el-tooltip
                  content="访问的组件路径，如：`system/user/index`，默认在`views`目录下"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
                组件路径
              </span>
              <el-input
                v-model="form.component"
                placeholder="请输入组件路径"
                @input="onInput()"
              /> </el-form-item
          ></el-col>
        </el-col>
        <el-col :span="24">
          <el-col :span="12">
            <el-form-item>
              <span slot="label"> 系统标识 </span>
              <el-select v-model="form.systemType">
                <el-option
                  v-for="item in uniqeGlobalDict$$['9']"
                  :key="item.code"
                  :label="item.name"
                  :value="`${item.code}`"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="显示排序" prop="orderNum">
              <el-input-number
                v-model="form.orderNum"
                controls-position="right"
                :min="0"
              />
            </el-form-item> </el-col
        ></el-col>

        <el-col :span="24" v-if="form.menuType != '4'">
          <el-col :span="12">
            <el-form-item>
              <span slot="label">
                <el-tooltip
                  content="选择隐藏则路由将不会出现在侧边栏，但仍然可以访问"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
                是否隐藏
              </span>
              <el-radio-group v-model="form.hideFlag">
                <el-radio
                  v-for="dict in sys_show_hide"
                  :key="dict.value"
                  :label="dict.value"
                  >{{ dict.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span slot="label">
                <el-tooltip
                  content="选择展示显示左侧菜单，否则隐藏左侧菜单"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
                左侧菜单
              </span>
              <el-radio-group v-model="form.showLeftFlag">
                <el-radio
                  v-for="dict in sys_normal_disable"
                  :key="dict.value"
                  :label="dict.value"
                  >{{ dict.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
      <el-col :span="12">
        <el-form-item>
          <span slot="label">
            <el-tooltip
              content="选择是外链则路由地址需要以`http(s)://`开头"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            是否外链
          </span>
          <el-radio-group v-model="form.outsideUrlFlag">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="form.menuType != '2'">
        <el-form-item>
          <el-input
            v-model="form.permission"
            placeholder="请输入权限标识"
            maxlength="100"
          />
          <span slot="label">
            <el-tooltip
              content="控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi('system:user:list')`)"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            权限字符
          </span>
        </el-form-item>
      </el-col>
      <el-col :span="24" v-if="form.menuType != '4'">
        <el-col :span="12">
          <el-form-item label-width="117px">
            <el-input
              v-model="form.redirect"
              placeholder="请输入重定向地址"
              maxlength="100"
            />
            <span slot="label">
              <el-tooltip
                content="重定向访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
              重定向地址
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-input
              v-model="form.businessType"
              placeholder="请输入权限标识"
              maxlength="100"
            />
            <span slot="label">
              <el-tooltip
                content="控制页面路由显示隐藏的标识字段，如：_blank&home"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
              权限标识
            </span>
          </el-form-item>
        </el-col>
      </el-col>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="handleSaveAddOrEdit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import TreeseLect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import IconSelect from "./IconSelect/index";
export default {
  name: "AddOrEdit",
  $dictKeyList: [
    {
      key: "9",
      name: "菜单管理系统标识",
    },
  ],
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      default: "add",
    },
    menuList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    munuData: {
      type: Object,
      default: () => {},
    },
  },
  components: { TreeseLect, IconSelect },
  data() {
    return {
      form: {
        parentId: null,
        orderNum: "",
        urlAddress: "",
        icon: "",
        hideFlag: false,
        outsideUrlFlag: false,
        menuName: "",
        permission: "",
        menuType: 3,
        pullDownFlag: false,
        systemType: "",
        showLeftFlag: true,
        businessType: "",
        redirect: "",
      },
      btnCode: "",
      rules: {
        menuName: [
          { required: true, message: "菜单名称不能为空", trigger: "blur" },
        ],
        orderNum: [
          { required: true, message: "菜单顺序不能为空", trigger: "blur" },
        ],
        systemType: [
          { required: true, message: "系统标识不能为空", trigger: "blur" },
        ],
      },
      sys_normal_disable: [
        { value: true, label: "展示" },
        { value: false, label: "隐藏" },
      ],
      sys_show_hide: [
        { value: true, label: "是" },
        { value: false, label: "否" },
      ],
      iconObj: {},
      iconLoad: 0,
    };
  },
  computed: {},
  watch: {
    "form.menuType"(n) {
      if (n == 4) {
        this.form.hideFlag = true;
      }
    },
  },
  methods: {
    /**
     * @description: 修复无法输入的问题
     * @Author: yangsibo
     * @Date: 2022-07-12 11:10:21
     * @return {*}
     */
    onInput() {
      this.$forceUpdate();
    },
    /**
     * @Description:
     * @Author: yangsibo
     * @Date: 2023-03-31 11:27:51
     * @return {*}
     */
    clearIconObj() {
      this.iconObj = {};
      this.form.icon = "";
    },
    /**
     * @description:
     * @Author: yangsibo
     * @Date: 2022-06-02 17:10:24
     * @param {*} node 选中节点
     * @return {*}
     */
    selectTreeNode(node) {
      this.form.systemType = `${node.systemType}`;
      this.form.childSystemType = `${node.childSystemType}`;
    },
    // 选择图标
    selected(icon, type) {
      this.iconObj = icon ? icon : {};
      this.form.icon = icon ? icon.icon : "";
      this.iconLoad = type;
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:01
     */
    close() {
      this.$emit("close", "showAddOrEdit");
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.menuName,
        children: node.children,
        // isDisabled: node.menuType == 4,
      };
    },
    /**
     * @description: 新增菜单
     * @Author: yangsibo
     * @Date: 2022-05-30 13:57:17
     */
    async insertSMenu() {
      if (this.form.menuType == 4) {
        this.form.logo = this.btnCode;
      }
      this.form.parentId = this.form.parentId ? this.form.parentId : "0";
      let { status } = await this.$http.menu.insertSMenu(this.form);
      if (status == 1) {
        this.$message({
          type: "success",
          message: "新增菜单成功",
          duration: 2000,
        });
        this.$emit("getMenuList");
        this.close();
      }
    },
    /**
     * @description: 保存表单
     * @Author: yangsibo
     * @Date: 2022-05-26 17:13:49
     */
    handleSaveAddOrEdit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.type == "add") {
            this.insertSMenu();
          } else {
            this.updateSMenuById();
          }
        } else {
          return false;
        }
      });
    },
    /**
     * @description: 获取菜单详情
     * @Author: yangsibo
     * @Date: 2022-05-30 11:38:32
     */
    async selectSMenuDetailById() {
      try {
        let { data } = await this.$http.menu.selectSMenuDetailById({
          id: this.munuData.id,
        });
        data.parentId = data.parentId === "0" ? null : data.parentId;
        this.btnCode = data.logo ? data.logo : "";
        Object.assign(this.form, data);
        this.form.systemType = `${this.form.systemType}`;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @description: 编辑菜单
     * @Author: yangsibo
     * @Date: 2022-05-30 13:55:34
     */
    async updateSMenuById() {
      try {
        let params = JSON.parse(JSON.stringify(this.form));
        params.parentId = params.parentId ? params.parentId : "0";
        if (this.form.menuType == 4) {
          params.logo = this.btnCode;
        }
        let { status } = await this.$http.menu.updateSMenuById(params);
        if (status == 1) {
          this.$message({
            type: "success",
            message: "编辑菜单成功",
            duration: 2000,
          });
          this.$emit("getMenuList");
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {},
  mounted() {
    if (this.type == "edit") {
      this.selectSMenuDetailById();
    }
  },
};
</script>
<style lang="scss" scoped>
.dialog-add-edit {
  ::v-deep .el-form-item {
    margin-bottom: 20px !important;
  }

  ::v-deep.vue-treeselect {
    .vue-treeselect__control {
      height: 40px;
      .vue-treeselect__placeholder,
      .vue-treeselect__single-value {
        line-height: 40px;
        font-size: 16px;
      }
    }
  }
  ::v-deep .icon-input {
    .el-input__prefix {
      left: 10px;
    }
  }
}
</style>
